import BulkActionsTable from "./BulkActionsTable";
export default BulkActionsTable;
